// extracted by mini-css-extract-plugin
export var filterButton = "_jp-1";
export var filtersContainer = "_jp-0";